import api from "./httpClient";
import { API_PATHS } from "./apiPaths";

const unwrap = (response) => response?.data?.data ?? response?.data ?? null;

export const getPrincipalDashboard = async () => unwrap(await api.get(API_PATHS.principal.dashboard()));
export const getPrincipalStudents = async () => unwrap(await api.get(API_PATHS.principal.students()));
export const getPrincipalTeachers = async (params) => unwrap(await api.get(API_PATHS.principal.teachers(params)));
export const getPrincipalClasses = async () => unwrap(await api.get(API_PATHS.principal.classes()));
export const getPrincipalAdmissions = async () => unwrap(await api.get(API_PATHS.principal.admissions()));
export const getPrincipalFees = async () => unwrap(await api.get(API_PATHS.principal.fees()));
export const getPrincipalPayroll = async () => unwrap(await api.get(API_PATHS.principal.payroll()));
export const getPrincipalExpenses = async () => unwrap(await api.get(API_PATHS.principal.expenses()));

export const getTenantPrincipals = async (tenantId) => unwrap(await api.get(API_PATHS.superAdmin.tenantPrincipals(tenantId)));
export const inviteTenantPrincipal = async (tenantId, payload) => unwrap(await api.post(API_PATHS.superAdmin.tenantPrincipals(tenantId), payload));
